import useStyles from './useStyles';

const useLinkButton = () => {
  const classes = useStyles();

  return { classes };
};

export default useLinkButton;
